import React, { useState } from "react";
import {
  Text,
  Group,
  Drawer,
  Avatar,
  Button,
  createStyles,
} from "@mantine/core";

import { useTranslation } from "react-i18next";
import { IconCreditCard, IconPhoneCall } from "@tabler/icons-react";
import useAuthentication from "stores/AuthenticationStore/authentication";
import "./DrawerUserInfo.scss";
import ModalSetting from "components/modal/modalSetting/ModalSetting";
import notiLogout from "assets/images/pngs/noti-logout.png";
import { GetUserProfile } from "@/dto/auth/response/auth-response";

type DrawerUserInfoProps = {
  opened: boolean;
  close: () => void;
  userInfo: GetUserProfile;
};

const useStylesUserInfo = createStyles((theme) => ({
  icon: {
    color:
      theme.colorScheme === "dark"
        ? theme.colors.dark[3]
        : theme.colors.gray[5],
  },

  name: {
    fontFamily: `Greycliff CF, ${theme.fontFamily}`,
  },
}));

const useStylesAvatar = createStyles((theme) => ({
  placeholder: {
    backgroundColor: theme.colors.primary[7],
    color: theme.colors.white,
  },
}));

const DrawerUserInfo: React.FC<DrawerUserInfoProps> = ({
  opened,
  close,
  userInfo,
}) => {
  const { t } = useTranslation();
  const [, actionAuth] = useAuthentication();
  const [openLogout, setOpenLogout] = useState(false);

  const { classes: classesUserInfo } = useStylesUserInfo();
  const { classes: classesAvatar } = useStylesAvatar();

  return (
    <Drawer
      opened={opened}
      onClose={close}
      withCloseButton
      position="right"
      size="sm"
    >
      <Group noWrap>
        {/* <Avatar src={userInfo.avatar} size={94} radius="md" /> */}
        <Avatar radius="md" size={94} classNames={classesAvatar}>
          {userInfo.fullName}
        </Avatar>
        <div>
          <Text fz="lg" fw={500} className={classesUserInfo.name}>
            {userInfo.fullName}
          </Text>
          <Text fz="xs" tt="uppercase" fw={700} c="dimmed">
            {userInfo.userRole}
          </Text>

          <Group noWrap spacing={10} mt={3}>
            <IconCreditCard
              stroke={1.5}
              size="1rem"
              className={classesUserInfo.icon}
            />
            <Text fz="xs" c="dimmed">
              {/* {userInfo.cusNo} */}
            </Text>
          </Group>

          <Group noWrap spacing={10} mt={5}>
            <IconPhoneCall
              stroke={1.5}
              size="1rem"
              className={classesUserInfo.icon}
            />
            <Text fz="xs" c="dimmed">
              {userInfo.primaryPhone}
            </Text>
          </Group>
        </div>
      </Group>
      <div className="drawer-action-wrapper">
        <Button
          color="primary"
          w="100%"
          onClick={() => {
            // actionAuth.logout();
            setOpenLogout(true);
          }}
        >
          {t("LOGOUT_TITLE")}
        </Button>
      </div>
      <ModalSetting
        opened={openLogout}
        close={() => setOpenLogout(false)}
        img={notiLogout}
        title={t<string>("DO_YOU_WANT_TO_LOG_OUT?")}
        btn={2}
      />
    </Drawer>
  );
};

export default DrawerUserInfo;
